export default __webpack_public_path__ + "static/media/success-offer.be0742b1.svg";